import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon, SettingsIcon, BellIcon, ShieldIcon, HelpCircleIcon, InfoIcon, LogOutIcon, ChevronRightIcon } from 'lucide-react';
interface MoreScreenProps {
  onLogout?: () => void;
}
export function MoreScreen({
  onLogout
}: MoreScreenProps) {
  const menuItems = [{
    icon: UserIcon,
    label: 'Account Settings',
    color: '#661806'
  }, {
    icon: ShieldIcon,
    label: 'Security',
    color: '#10B981'
  }, {
    icon: BellIcon,
    label: 'Notifications',
    color: '#F37024'
  }, {
    icon: HelpCircleIcon,
    label: 'Help & Support',
    color: '#3B82F6'
  }, {
    icon: InfoIcon,
    label: 'About',
    color: '#8B5CF6'
  }, {
    icon: LogOutIcon,
    label: 'Logout',
    color: '#EF4444'
  }];
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full min-h-screen bg-background pb-20" data-id="element-383">
      {/* Header */}
      <div className="bg-white px-6 py-5" data-id="element-384">
        <h1 className="text-xl font-bold text-textPrimary" data-id="element-385">More</h1>
      </div>

      <div className="px-6 py-6 space-y-6" data-id="element-386">
        {/* Profile Section */}
        <div className="bg-white rounded-2xl p-5 shadow-sm" data-id="element-387">
          <div className="flex items-center gap-4" data-id="element-388">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold" data-id="element-389">
              AK
            </div>
            <div className="flex-1" data-id="element-390">
              <h3 className="text-lg font-semibold text-textPrimary" data-id="element-391">
                Ahmed Khan
              </h3>
              <p className="text-sm text-textSecondary" data-id="element-392">+92 300 1234567</p>
            </div>
            <button className="text-accent" data-id="element-393">
              <SettingsIcon className="w-5 h-5" strokeWidth={2} data-id="element-394" />
            </button>
          </div>
        </div>

        {/* Menu Items */}
        <div className="bg-white rounded-2xl shadow-sm divide-y divide-gray-100" data-id="element-395">
          {menuItems.map((item, index) => {
          const Icon = item.icon;
          return <button key={index} onClick={item.label === 'Logout' ? onLogout : undefined} className="w-full px-5 py-4 flex items-center gap-4 hover:bg-gray-50 transition-colors first:rounded-t-2xl last:rounded-b-2xl" data-id="element-396">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: `${item.color}15`
            }} data-id="element-397">
                  <Icon className="w-5 h-5" style={{
                color: item.color
              }} strokeWidth={2} data-id="element-398" />
                </div>
                <span className="flex-1 text-left text-sm font-medium text-textPrimary" data-id="element-399">
                  {item.label}
                </span>
                <ChevronRightIcon className="w-5 h-5 text-textSecondary" strokeWidth={2} data-id="element-400" />
              </button>;
        })}
        </div>

        {/* App Version */}
        <div className="text-center pt-4" data-id="element-401">
          <p className="text-xs text-textSecondary" data-id="element-402">digiBOP v1.0.0</p>
          <p className="text-xs text-textSecondary mt-1" data-id="element-403">
            © 2024 Bank of Punjab
          </p>
        </div>
      </div>
    </motion.div>;
}